module.exports = __webpack_public_path__ + "img/CRM-registration.35b43aa7.png";